import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=ab6493c6&scoped=true"
import script from "./contracts.vue?vue&type=script&lang=js"
export * from "./contracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6493c6",
  null
  
)

export default component.exports